export const NEW = "NEW", UPDATE = "UPDATE", DELETE = "DELETE"